const currentYear = new Date().getFullYear();
const allAppointedYearData = [];

for (let year = currentYear; year >= 2003; year--) {
    allAppointedYearData.push({
        label: year.toString(),
        value: year.toString()
    });
}

allAppointedYearData.push({
    label: "Before 2003",
    value: "2002"
});

export const appointedYears = [
    {
        type: "Dropdown",
        id: "appointed-year",
        content: [
            {
                label: "Year",
                value: "",
                disabled: true
            },
           ...allAppointedYearData
        ]
    }
]